<template>
    <div class='layer-pop package-edit'>
        <div class='view-content'>
            <button class='close' @click='cancelPopup'><span class='blind'>팝업 닫기</span></button>
            <div class='left-area'>
                <div class='top-search'>
                    <select-form
                        :select-data="['전체', ...$parent.ticketData]"
                        :select-value="['', ...$parent.ticketTypes]"
                        :selected-value.sync='filter.ticketType'
                        class='w130px'
                        @update:set='load'
                    ></select-form>
                    <div class='com-search-input'>
                        <input v-model='filter.searchStr' placeholder='이용권 입력' type='text' @keydown.enter='load' />
                        <button class='search-btn' type='button' @click='load'>검색</button>
                    </div>
                </div>
                <div class='lesson-info-content com-scroll-y'>
                    <ul class='list'>
                        <li class='plus-btn'>
                            <button type='button' @click="selected = ''"><span class='blind'>추가하기</span></button>
                        </li>
                        <li
                            v-for='(item, index) in data.items'
                            :key='index'
                            :ref='`product-${item.cp_center_prod_id}`'
                            :class="selected == item.cp_center_prod_id ? 'on' : ''"
                            @click='selected = item.cp_center_prod_id'
                        >
                            <span class='icon-box'>
                                <span
                                    :class="'type-' + ($parent.ticketTypes.indexOf(item.cp_ticket_type_cd) + 1)"
                                    class='ico'
                                >{{ $parent.ticketData[$parent.ticketTypes.indexOf(item.cp_ticket_type_cd)] }}</span
                                >
                            </span>
                            <span
                                :class="'type-' + ($parent.ticketTypes.indexOf(item.cp_ticket_type_cd) + 1)"
                                class='title'
                            >{{ item.cp_namee }}</span
                            >
                            <span class='info'
                            >{{ item.cp_less_cnt }}회 / 유효기간 {{
                                    item.cp_period_cnt
                                }}{{ item.cp_period_type_cd == 'M' ? '개월' : '일' }} /
                                {{ (item.cp_category_temp_nm || '').replace(/\|/g, ' / ') }}</span
                            >
                            <span class='num'>{{ item.cp_sell_price | numberFormatFilter }} <small>원</small></span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class='right-area com-scroll-y'>
                <goods-use-detail :deletable='false' :inPopup='true' :prodNo='selected' @select='select'
                                  @cancel-popup='cancelPopup' />
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import GoodsUseDetail from './GoodsUseDetail';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SettingGoodsPackageSelectPopup',
    components: { LoadingSpinner, GoodsUseDetail },
    props: ['selectedProduct'],
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            filter: {},
            selected: '',
            data: [],
            pagingInfo: {...pagingInfo},
        };
    },
    watch: {
        selectedProduct(v) {
            this.selected = v;
        },
    },
    beforeMount() {
        this.selected = this.selectedProduct;
        this.filter = this.getFilterDefault();
        this.pagingInfo.limit = 1000;
    },
    mounted() {
        this.load();
    },
    methods: {
        getFilterDefault() {
            return {
                centerId: this.centerId,
                stockUseYn: 'true',
                ticketType: '',
                centerProductCategoryTemplateId: '',
                sortColumn: 'createAt',
                sortType: 'DESC',
                searchStr: '',
            };
        },
        load() {
            this.filter.sortType = this.filter.sortColumn == 'createAt' ? 'DESC' : 'ASC';
            api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: { ...this.pagingInfo, ...this.filter },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.setPageParams(res.data);
                    this.data = res.data;
                    if (this.selected) {
                        this.$nextTick(() => {
                            if (this.$refs[`product-${this.selected}`]) {
                                this.$el.getElementsByClassName('lesson-info-content')[0].scrollTop = this.$refs[`product-${this.selected}`][0].offsetTop - 100;
                            }
                        });
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        select(item) {
            this.$emit('select', item);
        },
        cancelPopup() {
            this.$emit('cancel-popup');
        },
    },
};
</script>

<style lang='scss' scoped>
.left-area {
    height: auto !important;

    .plus-btn::before {
        display: none;
    }
}

.right-area {
    height: auto !important;
    position: relative;
    padding-bottom: 0px !important;

    .com-table-wrap {
        margin-bottom: 30px;
    }

    .bottom-btn {
        position: sticky;
        bottom: 0;
        background-color: #fff;
        padding: 16px;
    }
}
</style>
